module.exports = __webpack_public_path__ + "img/PLAYER3-min.ed436764.png";